import React from 'react';
import './App.css';
import {BrowserRouter as Router, Redirect, Route} from "react-router-dom";
import BlogPost from "./Blog/BlogPost";
import BlogList from "./Blog/BlogList"
import Home from "./Home/Home";
import Nav from "./Nav/Nav";
import Footer from "./Footer/Footer";

function App() {
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <div>
                <Nav/>

                <Route path={"/"} exact component={Home}/>

                <Route path={"/2019-04-27-file-recovery*"}
                       render={() => <Redirect to={{pathname: "/blog/2019-04-27-file-recovery"}}/>}
                />

                <Route path={"/blog/"} exact component={BlogList}/>

                <Route path={"/blog/:key"} render={({match}) => {
                    return (<BlogPost blogKey={match.params.key}/>)
                }}/>

                <Footer/>
            </div>
        </Router>
    );
}

export default App;